import Skeleton from 'react-loading-skeleton'
import styled, { css } from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { ZoomButton } from '@velasca/ui/zoom-button'

export const ContainerGrid = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  justify-items: stretch;
  gap: 13px;
`

export const GridElement = styled.div<{ stretch: boolean; zoom: boolean }>`
  position: relative;
  ${(props) => (props.stretch ? 'grid-column: 1 / span 2;' : '')}

  ${(props) =>
    props.zoom &&
    css`
      cursor: zoom-in;
    `};
`

export const Image = styled(ResponsiveImage)<{
  imageWidth: number
  imageHeight: number
}>`
  width: 100%;
  aspect-ratio: ${({ imageWidth, imageHeight }) =>
    Math.round((imageWidth / imageHeight) * 100) / 100};

  .safari-lower-than-15 & {
    padding-top: ${({ imageWidth, imageHeight }) =>
      `${((imageHeight / imageWidth) * 100).toFixed(2)}%`};
  }
`

export const ImageSkeleton = styled(Skeleton)<{
  imageWidth: number
  imageHeight: number
}>`
  width: 100%;
  aspect-ratio: ${({ imageWidth, imageHeight }) =>
    Math.round((imageWidth / imageHeight) * 100) / 100};

  .safari-lower-than-15 & {
    padding-top: ${({ imageWidth, imageHeight }) =>
      `${((imageHeight / imageWidth) * 100).toFixed(2)}%`};
  }
`

const ArrowContainer = styled.div`
  user-select: none;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
`

export const LeftArrowContainer = styled(ArrowContainer)`
  z-index: 999999;
  left: 0;
`

export const RightArrowContainer = styled(ArrowContainer)`
  z-index: 999999;
  right: 0;
`

export const ZoomButtonStyle = styled(ZoomButton)`
  position: absolute;
  right: 15px;
  bottom: 22px;
  padding: 4px;
`

export const Model = styled.div<{
  isFullScreen: boolean
  width: number
  height: number
}>`
  #sketchfab-tile-player {
    width: 100%;
    height: 100%;
  }

  ${({ isFullScreen, width, height }) =>
    isFullScreen
      ? css`
          position: fixed;
          width: 100vw;
          height: 100vh;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          z-index: 999999;
        `
      : css`
          position: relative;
          width: 100%;
          aspect-ratio: ${Math.round((width / height) * 100) / 100};

          .safari-lower-than-15 & {
            padding-top: ${((height / width) * 100).toFixed(2)}%;
          }
        `}
`

export const VideoContainer = styled.div<{
  mediaWidth: number
  mediaHeight: number
}>`
  aspect-ratio: ${({ mediaWidth, mediaHeight }) =>
    `${mediaWidth}/${mediaHeight}`};
  height: auto;

  .safari-lower-than-15 & {
    padding-top: ${({ mediaWidth, mediaHeight }) =>
      `${((mediaHeight / mediaWidth) * 100).toFixed(2)}%`};
  }
`

export const VideoTile = styled.video`
  display: block;
  width: 100%;
  height: 100%;
`

export const DefectiveMedia = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.6rem;
  font-weight: 300;
`
